import { render } from "./columnarDetails.vue?vue&type=template&id=412cfb60&scoped=true"
import script from "./columnarDetails.vue?vue&type=script&lang=js"
export * from "./columnarDetails.vue?vue&type=script&lang=js"

import "./columnarDetails.vue?vue&type=style&index=0&id=412cfb60&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412cfb60"]])

export default __exports__